module.exports = __webpack_public_path__ + "__static/site-1751025561283/img/rooster.e6ff9660.jpg";